import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { Field, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Button from '../../../components/Button/Button';
import TextInput from '../../../components/Form/TextInput/TextInput';
import Loader from '../../../components/Loader/Loader';
import TextError from '../../../components/TextError/TextError';
import { useAppDispatch } from '../../../store/reducers';
import { AccountType, checkName, resetError, setUserAvatar, setUserName } from '../../../store/reducers/App/appSlice';
import { userNameValidationSchema } from '../../../validations/userName';
import ProfileDetails from '../ProfileDetails/ProfileDetails';
import styles from './StableAccounts.module.scss';
const StableAccounts = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [stableValueStatus, setStableValueStatus] = useState(false);
    const [searchUser, setSearchUser] = useState('');
    const pending = useSelector((state) => state.app.pending);
    const userInfo = useSelector((state) => state.app.userInfo);
    const localAvatar = useSelector((state) => state.app.localAvatar);
    const error = useSelector((state) => state.app.error);
    const [initialValues, setInitialValues] = useState({
        name: ''
    });
    const useUserNameValidationSchema = userNameValidationSchema();
    useEffect(() => {
        const newUserName = { name: userInfo ? userInfo.name : '' };
        setInitialValues(newUserName);
    }, [userInfo]);
    useEffect(() => {
        if (searchUser === '') {
            dispatch(resetError());
            return;
        }
        const debounce = setTimeout(() => {
            dispatch(checkName(searchUser));
        }, 300);
        return () => clearTimeout(debounce);
    }, [dispatch, searchUser]);
    useEffect(() => {
        if (localAvatar === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.photo)) {
            setStableValueStatus(true);
        }
    }, [localAvatar]);
    const handleSubmit = (values) => {
        if (localAvatar !== '' && localAvatar === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.photo)) {
            dispatch(setUserAvatar(localAvatar));
        }
        if (!(values.name === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name))) {
            dispatch(setUserName(values.name));
        }
        setStableValueStatus(false);
    };
    return (_jsx(_Fragment, { children: _jsx(Formik, Object.assign({ initialValues: initialValues, onSubmit: handleSubmit }, { children: ({ handleChange, handleBlur, values, handleSubmit }) => (_jsx(Form, Object.assign({ className: 'w-100', onSubmit: handleSubmit }, { children: _jsxs(ProfileDetails, Object.assign({ title: t('stable_details') }, { children: [_jsxs("div", Object.assign({ className: cn(styles.element, 'd-flex justify-content-between align-items-end') }, { children: [_jsx("div", Object.assign({ className: 'd-flex flex-column flex-1 position-relative' }, { children: _jsx(Field, { label: t('stable_name'), type: "text", onChange: handleChange, onBlur: handleBlur, name: "name", id: "name", placeholder: t('text'), className: cn(styles.input, 'flex-1'), value: values.name, component: TextInput, onInput: (value) => {
                                            setSearchUser(value.target.value);
                                            setStableValueStatus(true);
                                        }, defaultValue: values.name }) })), (pending === null || pending === void 0 ? void 0 : pending.includes(AccountType.USER_NAME)) ? (_jsx(Button, { className: cn('w-100 flex-1'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx("div", Object.assign({ className: cn('d-flex align-content-center flex-1', styles.changes) }, { children: _jsx(Button, { disabled: !!error, type: 'submit', size: 'xl', height: 'sm', color: stableValueStatus ? 1 : 7, text: t('save_changes') }) })))] })), error && _jsx(TextError, { className: styles.errorText, text: error })] })) }))) }), JSON.stringify(initialValues)) }));
};
export default StableAccounts;
